import { render, staticRenderFns } from "./DealStatisticsDialog.vue?vue&type=template&id=84c9a82e&"
import script from "./DealStatisticsDialog.vue?vue&type=script&lang=ts&"
export * from "./DealStatisticsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports